import React from 'react';

const AppleStore = ({ ...props }: React.HTMLAttributes<SVGElement>): JSX.Element => {
  return (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.323 10.035a4.29 4.29 0 012.042-3.598 4.39 4.39 0 00-3.458-1.87c-1.456-.152-2.866.871-3.608.871-.756 0-1.898-.855-3.127-.83a4.606 4.606 0 00-3.876 2.364c-1.676 2.901-.426 7.166 1.18 9.511.803 1.149 1.741 2.432 2.97 2.386 1.202-.05 1.65-.766 3.102-.766 1.437 0 1.858.766 3.111.737 1.29-.02 2.103-1.153 2.878-2.313a9.5 9.5 0 001.316-2.68 4.145 4.145 0 01-2.53-3.812zM12.956 3.025A4.223 4.223 0 0013.922 0a4.296 4.296 0 00-2.78 1.438 4.018 4.018 0 00-.99 2.913 3.552 3.552 0 002.804-1.326z"
        fill="#1F2D27"
      />
    </svg>
  );
};

export { AppleStore };
